<template>
  <div class="c-setting">
    <div v-if="!leTbS" class="c-title">
      <span><c-svg t="translate" class="translate"></c-svg>{{ $T('common.env_setting') }}</span>
    </div>

    <template v-if="setting_groups != null">
      <template v-for="(setting_group, index) in setting_groups">
        <div class="c-subtitle" :class="{ danger: setting_group.danger }">{{ setting_group.title }}</div>
        <div class="c-rows" :class="{ danger: setting_group.danger }">
          <setting-row
            v-for="setting in setting_group.settings"
            :key="setting.id"
            :settingIndex="index"
            :settingKey="setting.id"
            :setting="setting"
            @click-button="onClickButton"
            @change-value="onChangeParam"
          />
        </div>
      </template>
    </template>

    <single-input-dialog
      v-if="dialog.target != null"
      ref="single-input-dialog"
      :open="dialog.open"
      :dialogKey="dialog.target.id"
      :dialogType="dialog.target.dialogType"
      :dialogTitle="dialog.target.dialogTitle"
      :fieldName="dialog.target.id"
      :inputLabel="dialog.target.inputLabel"
      :initValue="dialog.target.value"
      :items="dialog.target.items"
      :itemText="dialog.target.itemText"
      :itemValue="dialog.target.itemValue"
      :veeValidate="dialog.target.veeValidate"
      :required="dialog.target.required"
      :counter="dialog.target.counter"
      :apiErrors="apiErrors"
      :onSending="sending"
      @close="onCloseDialog"
      @save="onChangeParam"
    />

    <country-input-dialog v-if="countrySetting" :setting="countrySetting" @close-dialog="onCloseCountryDialog" />
  </div>
</template>

<script>
import { CONST } from '../../constant';
import UTILS from '../../utils/utils';
import countryInputDialog from '../common/CountryInputDialog.vue';
import settingRow from '../common/SettingRow.vue';
import singleInputDialog from '../common/SingleInputDialog.vue';
import { getMemberSetting, updateMemberSetting } from '../../api/member';

export default {
  beforeRouteEnter(route, redirect, next) {
    console.log('beforeRouteEnter');
    UTILS.startLoading();
    getMemberSetting()
      .then(function(response) {
        UTILS.stopLoading();
        next(vm => vm.setSetting(response));
      })
      .catch(function(error) {
        UTILS.stopLoading();
        console.error('failed to get member data', error);
        next(error);
      });
  },
  beforeRouteUpdate(to, from, next) {
    console.log('beforeRouteUpdate');
    UTILS.startLoading();
    this.setting_groups = null;
    var _this = this;
    getMemberSetting()
      .then(function(response) {
        UTILS.stopLoading();
        _this.setSetting(response);
        next();
      })
      .catch(function(error) {
        UTILS.stopLoading();
        console.error('failed to get member data', error);
        next(error);
      });
  },
  methods: {
    setSetting(loadedSetting) {
      this.loaded_setting = loadedSetting;
      var copied = [];
      this.setting_map = null;
      this.setParam('language', 'value', loadedSetting.language_code);
      this.setParam('country', 'value', loadedSetting.country_code);
      this.setParam('timezone', 'value', loadedSetting.timzone_code);
      this.setting_groups = this.setting_groups_template;
    },
    setParam(key, param, value) {
      var setting = this.getSetting(key);
      if (setting == null)
        return console.error('failed to update param : ' + JSON.stringify({ key: key, param: param, value: value }));
      console.log(key + '.' + param + ' value : ' + setting[param] + ' => ' + value);
      setting[param] = value;
    },
    getSetting(key) {
      if (this.setting_map == null) {
        // create new map
        var map = {};
        for (var groupIdx in this.setting_groups_template) {
          for (var settingIdx in this.setting_groups_template[groupIdx].settings) {
            var setting = this.setting_groups_template[groupIdx].settings[settingIdx];
            if (map[setting.id] != null) {
              console.error(setting.id + ' is duplicated!');
              continue;
            }
            map[setting.id] = setting;
          }
        }
        this.setting_map = map;
      }
      var setting = this.setting_map[key];
      if (setting == null) {
        console.error(key + ' is not exist!');
      }
      return setting;
    },
    setValue(key, value) {
      this.setParam(key, 'value', value);
    },
    onChangeParam(settingKey, newParam, oldParam) {
      this.sending = true;

      var setting = this.getSetting(settingKey);

      let data = {
        id: setting.id,
        value: newParam,
      };

      var _this = this;
      updateMemberSetting(data)
        .then(function(response) {
          _this.setValue(settingKey, newParam);
          var setting = _this.getSetting(settingKey);
          _this.dialog.open = false;
          _this.sending = false;
          if (settingKey === 'language') {
            // The server resolves the display language from the `lang` cookie ahead of the
            // saved member setting, so update the cookie to the newly chosen language before
            // the full reload — otherwise the page reloads in the previous language.
            document.cookie = 'lang=' + encodeURIComponent(newParam) + ';path=/';
          }
          location.reload();
        })
        .catch(function(error) {
          console.log(error);

          var setting = _this.getSetting(settingKey);
          console.log('set setting api errors');
          if (!_this.apiErrors[setting.id]) {
            _this.apiErrors[setting.id] = {};
          }

          if (error.errors && (error.errors.id || error.errors.value)) {
            _this.apiErrors[setting.id][data.value] = error.errors.id ? error.errors.id[0] : error.errors.value[0];
          } else {
            _this.apiErrors[setting.id][data.value] = window.$T('error.unknown');
          }
          _this.sending = false;
          _this.$refs['single-select-dialog'].reValidate();
        });
    },
    onClickButton(settingKey) {
      var setting = this.getSetting(settingKey);
      if (settingKey == 'country') {
        this.countrySetting = setting;
        return;
      }
      this.dialog.target = setting;
      this.dialog.open = true;
    },
    onCloseDialog(settingKey) {
      this.dialog.open = false;
      this.dialog.target = null;
      this.apiErrors = {};
      this.sending = false;
    },
    onCloseCountryDialog() {
      this.countrySetting = null;
    },
  },
  components: {
    'setting-row': settingRow,
    'single-input-dialog': singleInputDialog,
    'country-input-dialog': countryInputDialog,
  },
  data() {
    return {
      dialog: {
        open: false,
        target: null,
      },
      countrySetting: null,
      apiErrors: {},
      sending: false,
      loaded_settings: null,
      setting_map: null,
      setting_groups: null,
      setting_groups_template: [
        {
          title: this.$T('page.setting.sub_title.basic_setting'),
          settings: [
            {
              id: 'language',
              type: 'value-button',
              title: this.$T('attributes.language'),
              explain: this.$T('page.setting.language.explain'),
              supplement: this.$T('page.setting.supplement.reload'),
              value: '',
              editValue: function(component, value) {
                return $commin.defaultLanguages(value).value;
              },
              disabled: false,
              dialogType: 'select',
              items: this.$commin.defaultLanguages(),
              itemText: 'value',
              itemValue: 'key',
              dialogTitle: this.$T('common.change_attribute', { attr: this.$T('attributes.language') }),
              inputLabel: this.$T('attributes.language'),
              veeValidate: '',
            },
            {
              id: 'country',
              type: 'value-button',
              title: this.$T('attributes.country'),
              explain: this.$T('page.setting.country.explain'),
              supplement: this.$T('page.setting.supplement.reload'),
              value: '',
              editValue: function(component, value) {
                return $commin.countries(value).value;
              },
              disabled: false,
              dialogType: 'select',
              items: this.$commin.countries(),
              itemText: 'value',
              itemValue: 'key',
              dialogTitle: this.$T('common.change_attribute', { attr: this.$T('attributes.country') }),
              inputLabel: this.$T('attributes.country'),
              veeValidate: '',
            },
            {
              id: 'timezone',
              type: 'value-button',
              title: this.$T('attributes.timezone'),
              explain: this.$T('page.setting.timezone.explain'),
              supplement: this.$T('page.setting.supplement.reload'),
              value: '',
              editValue: function(component, value) {
                return $commin.timezones(value).value;
              },
              disabled: false,
              dialogType: 'select',
              items: this.$commin.timezones(),
              itemText: 'value',
              itemValue: 'key',
              dialogTitle: this.$T('common.change_attribute', { attr: this.$T('attributes.timezone') }),
              inputLabel: this.$T('attributes.timezone'),
              veeValidate: '',
            },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.translate {
  transform: translateY(5px) !important;
}
</style>
